<template>
  <div :class="embedded ? 'platform-code' : 'modal-content'">
    <button v-if="!embedded" type="button" class="close" @click="$emit('closeModal')">
      <span aria-hidden="true"><svg v-svg symbol="x" size="0 0 17 17"></svg></span>
    </button>
    <div class="modal-body" :class="{ large: !platform.site, 'p-0': embedded }">
      <div v-if="!embedded" class="title-h2 pb-2 pr-4">
        {{ $t(`platform.${platform.site ? "code" : "link"}_for_a_platform`) }}:
        {{ platform.id }}
      </div>
      <div class="form-item mb-4" v-if="domains && domains.length">
        <div class="form-item__label">
          {{ $t("platforms.domain") }}
        </div>
        <div class="form-item__field">
          <custom-multiselect v-model="currentDomain" :list="domains" class="mb-4" :allowEmpty="false">
            <template v-slot:block="props">
              <div class="domain-wrapper">
                <span class="domain-wrapper__title">{{ currentDomain ? props.value.domain : "" }}</span>
              </div>
            </template>
            <template v-slot:list="props">
              <div class="domain-wrapper pl-2">
                <span class="domain-wrapper__title line_right font-weight-bold">{{ props.value.domain }}</span>
                <span class="domain-wrapper__date">{{ props.value.expires_at || $t("system") }}</span>
              </div>
            </template>
          </custom-multiselect>
        </div>
      </div>
      <CheckBoxWrapper v-if="platform.site" class="mb-3 p-0 col-12" v-model="platform.facebook_web_view_redirect" :text="$t('platform.redirect_to_chrome')" />
      <CheckBoxWrapper v-if="platform.site" class="mb-4 p-0 col-12" v-model="trafficback_settings" @input="setTrafficbackSettings" :text="$t('platform.site.settings') + ' Trafficback'" />
      <template v-if="platform.site && trafficback_settings">
        <div class="mb-4">
          <div class="form-item" v-for="(el, id) of trafficList" :key="id">
            <label :for="el.name" class="form-item__label">
              {{ $t(`platform.modal.${el.name}`) }}
            </label>
            <div class="form-item__field">
              <input :name="el.name" v-model.trim="trafficURLList[el.value]" type="url" placeholder="https://" pattern="https://.*" @blur="setTrafficbackSettings" @input="replaceInput(el.value, $event.target.value)" />
            </div>
          </div>
        </div>
      </template>
      <PlatformValue :platform="platform" :selectDomain="currentDomain" :trafficSettings="trafficSettings" :showSettingsLink="showSettingsLink" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import "@/assets/css/_tubs.scss";
import "@/assets/css/_code.scss";
import "@/assets/css/_modal.scss";
import serviceDomain from "@/api/serviceDomain";
import PlatformValue from "@/components/PlatformValue";
import CheckBoxWrapper from "@/components/CheckBoxWrapper.vue";
import subaccsService from "@/api/subaccsService";
import trafficbackSettings from "@/mixins/trafficbackSettings";
import { refreshSelfHostedStatus, showSavedAlert } from "@/helpers/selfHostedScript";

export default {
  name: "PlatformModal",
  components: {
    PlatformValue,
    CheckBoxWrapper,
  },
  props: {
    platform: {
      type: Object,
      default: null,
    },
    showSettingsLink: {
      type: Boolean,
      default: true,
    },
    // Shown on the platform card instead of a modal: no close button and title
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [trafficbackSettings],
  data() {
    return {
      domains: [],
      currentDomain: null,
      allowNativeWebPush: true,
    };
  },
  computed: {
    ...mapGetters({
      featureFlags: "user/getFeatureFlags",
    }),
  },
  methods: {
    changeFacebookRedirect() {
      const payload = {
        facebook_web_view_redirect: Number(this.platform.facebook_web_view_redirect),
      };

      subaccsService.changeFacebookRedirect(this.platform.id, payload).then((res) => {
        if (res && res.status === 200) {
          showSavedAlert(this, this.platform.id, {
            title: this.$t(`platforms.${this.platform.facebook_web_view_redirect ? "added" : "removed"}_redirect`),
          });
          return;
        }
        this.$alert({
          title: this.$t("sent_error"),
          text: res.message,
        });
      });
    },
    replaceInput(el, value) {
      if (!el || !value) {
        return;
      }

      this.trafficURLList[el] = value.replace(/"/g, "");
    },
  },
  watch: {
    "platform.facebook_web_view_redirect": {
      handler() {
        this.changeFacebookRedirect();
      },
    },
    currentDomain: {
      immediate: false,
      handler(val, oldVal) {
        if (val && val.domain) {
          const payload = {
            id: this.platform.id,
            domain: val.domain,
          };
          serviceDomain.setCurrentDomain(payload).then(() => {
            // The domain is baked into the self-hosted script; the first value is just the saved one
            if (oldVal && this.platform.site) {
              refreshSelfHostedStatus(this, this.platform.id);
            }
          });
        }
      },
    },
  },
  mounted() {
    const payload = {
      site: this.platform.site === 2 ? 1 : this.platform.site,
    };
    serviceDomain
      .getDomainModal(payload)
      .then((resp) => {
        if (resp && resp.status === 200) {
          this.domains = resp.data.data;
        }
      })
      .then(() => {
        serviceDomain.getCurrentDomain(this.platform.id).then((resp) => {
          if (resp) {
            if (resp.data.status === 200) {
              this.currentDomain = resp.data.data;
              return;
            }
          }
          this.currentDomain = this.domains[0];
        });
      });
  },
};
</script>
<style lang="scss" scoped>
.domain-wrapper {
  display: flex;
  flex: 1;

  &__title {
    color: #141414;

    &.line_right {
      border-right: 1px solid #e5e5ea;
    }
  }

  &__date {
    margin-left: 12px;
  }
}
.form-item {
  padding-bottom: 0;
}
</style>
